import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {CSSProperties} from 'react';
import {CampusDashboardCard} from '../Dashboard/CampusDashboardCard';
import {connect} from 'react-redux';
import * as Request from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';

class Props extends Tgcc.BaseProps {
    userInfo: Tgcc.UserInfo;
    loginData: Tgcc.LoginData;
}


const rowStyle: CSSProperties = {
    padding: '5px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: '11px',
    marginTop: '3px'
}
let addrRow2Style = Object.assign({}, rowStyle, {marginTop: '0', padding: '0px 5px'});
let checkRowStyle= Object.assign({}, rowStyle, {justifyContent: 'left'} )

const labelStyle: CSSProperties = {
    lineHeight: '12px',
    letterSpacing: '1px',
    display: 'flex',
    alignSelf: 'center',
    fontSize: '18px',
    fontWeight: 100,
    color: Tgcc.Styles.darkTextColor,
    maxWidth: '35%',
    fontFamily:'Reitam'
}
let checkLabelStyle = Object.assign({}, labelStyle, {maxWidth: '80%'});

const inputStyle: CSSProperties = {
    fontSize: '18px',
    display: 'flex',
    flexGrow: 2,
    marginLeft: '6px',
    padding: '0 5px',
    lineHeight: '18px',
    height: '30px',
    fontFamily:'AveriaSerifLightItalic',
    border:'1px solid #E9E6E6',
    color:'rgba(66, 66, 66, 0.8)'
}

let nameStyle = Object.assign({}, inputStyle, {width: '70px'});
let phoneStyle = Object.assign({}, inputStyle, {width: '110px'});
let checkStyle = Object.assign({}, inputStyle, {width: '15px', height: '15px', flexGrow: null});
let addrStyle = Object.assign({}, inputStyle, {width: '120px'});
let cityStyle = Object.assign({}, inputStyle, {width: '80px', marginLeft: '0', marginTop: '3px'});
let stateStyle = Object.assign({}, inputStyle, {width: '36px', marginTop: '3px', flexGrow: '0', textAlign:'center'});
let zipStyle = Object.assign({}, inputStyle, {width: '45px', marginTop: '3px'});
let labelSOBStyle = Object.assign({}, labelStyle, {marginTop: '3px'});
let schStyle = Object.assign({}, inputStyle, {width: '315px', marginLeft: '0'});
let orgStyle = Object.assign({}, inputStyle, {width: '60px'});

const btnStyle: CSSProperties= {
    width:'225px',
    height:'40px',
    lineHeight:'2.5',
    textAlign:'center',
    margin:'auto',
    fontFamily:'Reitam',
    color:'white',
    backgroundColor:'#5E6A74',
    cursor:'pointer'
}
class acctState{
    user: Tgcc.UserInfo;
    error: string;
    isWaiting: boolean;
}

export class _RealCampusAccountInfo extends React.Component<Props, any>{

    state = {
        user: new Tgcc.UserInfo,
        error: null,
        isWaiting: false
    }

    componentWillMount(){
        this.setState( {user: this.props.userInfo});
    }    

    componentWillReceiveProps(newProps: Props){
        this.setState( {user: newProps.userInfo});       
    }

    updateUser = () => {
        var loginData = this.props.loginData;
        if(!loginData){
            this.setState({error: "not logged in", isWaiting: false});
        } else {
            this.setState({isWaiting: true});
            Request.updateUser(loginData, this.state.user, this.updateComplete, this.updateError);
        }
    }
    
    updateComplete = () => {
        this.setState({error: 'account updated', isWaiting: false});
        this.props.dispatch({type: Tgcc.StateAction.SetUserInfo, payload: this.state.user});
    }

    updateError = (err) => {
        this.setState({error: err, isWaiting: false});
    }

    fieldChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var el = evt.currentTarget;
        var item = {};

        if(el.name == "Phone")
            item[el.name] = Tgcc.formatPhoneNumber(el.value);
        else if(el.name == "smsAllowed")
            item[el.name] = el.checked
        else
            item[el.name] = el.value;

        this.setState({error: null, user: Object.assign({}, this.state.user, item)});
    }

    render(){
        var user = this.state.user || new Tgcc.UserInfo;
        var err = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : <div style={Tgcc.Styles.error}>&nbsp;</div>

        return (
            <CampusDashboardCard title="Update Info" >
                <div style={rowStyle}>
                    <div style={labelStyle} className="campusAccInpt">Name</div>
                    <input name="firstName" type='text' style={nameStyle} value={user.firstName||""} placeholder="first name" onChange={this.fieldChanged} />
                    <input name="lastName" type='text' style={nameStyle} value={user.lastName||""} placeholder="last name" onChange={this.fieldChanged} />
                </div>
                <div style={rowStyle}>
                    <div style={labelStyle} className="campusAccInpt">Phone</div>
                    <input name="phone" type='tel' style={phoneStyle} value={user.phone||""} placeholder="daytime phone" onChange={this.fieldChanged}/>
                </div>
                <div style={checkRowStyle}>
                    <div style={checkLabelStyle} className="campusAccInpt">Send text notifications</div>
                    <input name="smsAllowed" type='checkbox' style={checkStyle} checked={user.smsAllowed || false} onChange={this.fieldChanged} />
                </div>
                <div style={rowStyle}>
                    <div style={labelStyle} className="campusAccInpt">Address</div>
                    <input name="address" type='text' style={addrStyle} value={user.address||""} placeholder="shipping address" onChange={this.fieldChanged}/>
                </div>
                <div style={addrRow2Style}>
                    <input name="city" type='text' style={cityStyle} value={user.city||""} placeholder="city" onChange={this.fieldChanged} />
                    <input name="state" type='text' maxLength={2} style={stateStyle} value={user.state||""} placeholder="state" onChange={this.fieldChanged} />
                    <input name="zip" type='text' maxLength={8} style={zipStyle} value={user.zip||""} placeholder="zip" onChange={this.fieldChanged} />
                </div>
                <div style={rowStyle}>
                    <div style={labelSOBStyle} className="campusAccInpt">School</div>
                    <input name="schoolOrBusiness" type='text' style={schStyle} value={user.schoolOrBusiness||""} placeholder="Clemson, IBM, GE, etc." onChange={this.fieldChanged}/>
                </div>
                <div style={rowStyle}>
                    <div style={labelStyle} className="campusAccInpt">Organization</div>
                    <input name="organization" type='text' style={orgStyle} value={user.organization||""} placeholder="Beta Club, Kappa Delta, etc." onChange={this.fieldChanged}/>
                </div>
                {err}
                <div style={btnStyle} onClick={this.updateUser}>Update</div>
            </CampusDashboardCard>
        )
    }

}


const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        userInfo: state.UserInfo,
        loginData: state.LoginData
    };
};
export var RealCampusAccountInfo = connect(mapStateToProps)(Radium(_RealCampusAccountInfo));
